import * as types from "../constants";

const initialState = {
  isLoading: true,
  error: null,
  items: [],
};

export default function partStructureReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_PART_STRUCTURE_INIT:
      return { ...state, error: null, isLoading: true };

    case types.GET_PART_STRUCTURE_SUCCESS:
      return { ...state, isLoading: false, items: action.data.data };

    case types.GET_PART_STRUCTURE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    default:
      return state;
  }
}
